'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const jsxRuntime = require('react/jsx-runtime');
const components_marketing_ZapCard_ZapCard = require('../ZapCard/ZapCard.cjs.js');
require('../../display/Icon/Icon.cjs.js');
require('../../navigation/Link/Link.cjs.js');
require('react');
require('react-imgix');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');

const root = "_root_12vxn_1";
const container = "_container_12vxn_15";
const styles = {
	root: root,
	container: container
};

const ZapCardSection = ({ items, layout = "card" }) => {
  var _a;
  if (items.length > 3 && layout !== "auto") {
    console.error("Max 3 items are allowed in ZapCardSection component");
  }
  const maxItems = layout === "auto" ? items.length : 3;
  return jsxRuntime.jsx("div", { className: styles.root, "data-zds": true, children: jsxRuntime.jsx("div", { className: styles.container, "data-layout": layout, "data-zds": true, children: (_a = items === null || items === void 0 ? void 0 : items.slice(0, maxItems)) === null || _a === void 0 ? void 0 : _a.map((_a2) => {
    var { color = theme_Colors.Colors.PrimeWhite, href } = _a2, rest = tslib_es6.__rest(_a2, ["color", "href"]);
    return jsxRuntime.jsx(components_marketing_ZapCard_ZapCard.ZapCard, Object.assign({}, rest, { color, href, layout }));
  }) }) });
};

exports.ZapCardSection = ZapCardSection;
//# sourceMappingURL=ZapCardSection.cjs.js.map
